import './App.css';
import Header, { scrollToSection } from './components/Header';
import { useEffect } from 'react';
import { useTitleCardPos } from './TitleCards';
import ProfileBlurb from './components/ProfileBlurb';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';

function Home() {

  const { profile, project, contact } = useTitleCardPos();

  useEffect(() => {
    const section = sessionStorage.getItem('scrollToSection');
    if (!section) return;

    // allow DOM/layout to settle and refs to be set
    const refMap = { profile, project, contact };
    const targetRef = refMap[section];


    setTimeout(() => {
      // if targetRef is null, scrollToSection will do nothing, so this is safe 
      // even if the section name is invalid or the ref isn't set for some reason
      scrollToSection(section, targetRef);
      try { sessionStorage.removeItem('scrollToSection'); } catch (e) {}
    }, 150);
  }, [profile, project, contact]);

  return (
    <div className="page">
      <Header />
      <ProfileBlurb/>
      <Projects/>
      <Contact/>
      <Footer/>
    </div>
  );
}

export default Home;